"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/BulletList` instead */
export const BulletList = createSVGIcon(
  <>
    <path
      d="M2 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM2 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM2 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 3H8M23 12H8M23 21H8"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "BulletList",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
